/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */


import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useDeleteCategoryMutation } from "../../Store/Services/CategoryService";
import { closeCategoryModal } from "../../Store/Slices/categorySlice";
import DeletePopUp from "../Shared/DeletePopUp";

const DeleteCategory = () => {

    const dispatch = useDispatch();
    const category = useSelector((state) => state.category);

    const [deleteCategory] = useDeleteCategoryMutation();

    const onDeleteConfirm = async () => {
        const id = category.selectedCategory;
        try {
          const response = await deleteCategory(id);
          const deletedCategory = response.data; 
          toast.success("Category successfully deleted!", {position:'bottom-right'});
        } catch (err) {
          console.error("Failed to delete category: ", err);
          toast.error("Error, something went wrong!", {position:'bottom-right'});
        }
        dispatch(closeCategoryModal());
      };

    return (
        <DeletePopUp
            data="Category"
            close={() => dispatch(closeCategoryModal())}
            onDeleteConfirm={onDeleteConfirm}
        />
    );
}

export default DeleteCategory
